// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

import App from '@/components/App.vue';
import router from './router';
import store from './store';
import { isDevelopment } from './utils/environment';
/* eslint-enable */


Vue.config.productionTip = false;

// Don't set up sentry on localhost/sunbeam
if (!isDevelopment && process.env.SENTRY_DSN) {
  // process vars get set by Docker during build
  Raven.config(process.env.SENTRY_DSN, {
    release: process.env.VERSION,
    environment: process.env.SENTRY_ENV,
  })
  .addPlugin(RavenVue, Vue)
  .install();
}

Raven.context(() => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
  });
});

// fix for back-forward cache for Safari, see
// https://stackoverflow.com/questions/8788802/prevent-safari-loading-from-cache-when-back-button-is-clicked
window.onpageshow = function (event) { // eslint-disable-line func-names
  if (event.persisted) {
    window.location.reload();
  }
};



// WEBPACK FOOTER //
// ./src/main.js